export const siteConfig = {
  debounce: 500,
  pageSize: 15,
}
